import { useState } from "react";
import {
  List,
  Card,
  TabContent,
  TabPane,
  Nav,
  NavLink,
  NavItem,
} from "reactstrap";
import classnames from "classnames";
import { ruleDescriptions } from "../utils/attrRules";
import style from "./Information.module.scss";

export default function AttrRules() {
  const [current, setCurrent] = useState<number>(1);
  return (
    <div className={style.tabs}>
      <Card body>
        <Nav tabs className={style.links}>
          <NavItem>
            <NavLink
              className={classnames({ active: current === 1 })}
              onClick={() => setCurrent(1)}
            >
              Alcance
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: current === 2 })}
              onClick={() => setCurrent(2)}
            >
              Reglas de codificación
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={current}>
          <TabPane tabId={1} title="Alcance" className="pt-4">
            <h4 className="mb-3">Alcance</h4>
            <p>
              La aplicación para Reglas de Codificación de Texto (RCT) fue
              elaborada por la Dirección Nacional de Ordenamiento Territorial del
              Ministerio de Vivienda y Ordenamiento Territorial a los efectos de
              generar códigos para el manejo de información geográfica digital.
            </p>
            <p>
              Dichos códigos pueden ser empleados en catálogos de objetos,
              nombres de campos utilizados en las bases de datos geográficas,
              entre otros.
            </p>
            <p>
              Los criterios que se utilizaron para la codificación se basaron en
              las recomendaciones de la Real Academia Española (RAE) para la
              elaboración de abreviaturas y se tomaron los métodos de
              truncamiento y la contracción. Se consideraron como límite del
              resultado codificado los 10 caracteres, ya sean alfabéticos como
              numéricos.
            </p>
          </TabPane>
          <TabPane tabId={2} title="Reglas de codificación" className="pt-4">
            <h4 className="mb-3">Reglas de codificación</h4>
            <List type="disc" className={style.rules}>
              <li>
                Eliminar de los conceptos artículos, contracciones y
                preposiciones.
              </li>

              {Object.values(ruleDescriptions).map((desc) => (
                <li key={`rule-desc-${desc.id}`}>
                  ({desc.id}) {desc.title}
                </li>
              ))}
            </List>
          </TabPane>
        </TabContent>
      </Card>
    </div>
  );
}
